import { render, staticRenderFns } from "./dateCalculation.vue?vue&type=template&id=65d346a9&scoped=true&"
import script from "./dateCalculation.vue?vue&type=script&lang=js&"
export * from "./dateCalculation.vue?vue&type=script&lang=js&"
import style0 from "./dateCalculation.vue?vue&type=style&index=0&id=65d346a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d346a9",
  null
  
)

export default component.exports